import styles from "./chart.module.css"

import React from "react"
import * as recharts from "recharts"
import cx from "classnames"
import * as util from "activities/util"
import * as fonts from "shared/fonts"

export const ColoredFraction = ({top, bottom}) => (
  <span className={styles["fraction"]}>
    {top} <span className={styles["percent"]}>({bottom})</span>
  </span>
)

export const pieDefaults = {
  label: "",
  dataKey: "value",
  data: [],
  innerData: [],
  innerDataColor: "#991125",
  innerDataAngle: 0,
  colors: [
    "#FFBB00",
    "#64D254",
    "#C4A8DF",
    "#FF91B0",
    "#FF4444",
    "#6EC5EF",
    "#005F8B",
    "#00BDDC",
    "#65DFC5",
    "#9E6CC7",
    "#FF881F",
    "#FFE7AF",
    "#00637A",
    "#FFCBCF",
    "#006AF9",
    "#FFA971",
    "#EDFCAE",
    "#A7DD00",
    "#077259",
    "#A8AFDA"
  ]
}

export const PieChartTooltip = ({total, payload}) => {
  if (payload && payload.length > 0) {
    const details = payload[0]
    const color = details.payload.fill
    return (
      <div className={cx(styles["pie-tooltip"], fonts.getFontClass())}>
        <div className={styles["with-indicator"]}>
          <span className={styles["indicator"]} style={{background: color}} />
          <span className="name">{details.name}</span>
        </div>
        <span className={styles["details"]}>
          <ColoredFraction top={util.formatDollarsNoCents(details.value)} bottom={util.formatPercent(details.value / total)} />
        </span>
      </div>
    )
  } else {
    return <span />
  }
}

export const pieTooltipStyles = {
  background: "white",
  borderRadius: 4,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
  padding: 10,
  width: 230,
  height: 32,
  textAlign: "left",
  boxSizing: "content-box",
  lineHeight: 1
}

export class PieChart extends React.Component {
  render() {
    let {colors, data, dataKey, label, innerData, innerDataColor, innerDataAngle} = this.props
    colors = colors || pieDefaults.colors
    data = data || pieDefaults.data
    dataKey = dataKey || pieDefaults.dataKey
    label = label || pieDefaults.label
    innerData = innerData || pieDefaults.innerData
    innerDataColor = innerDataColor || pieDefaults.innerDataColor
    innerDataAngle = innerDataAngle || innerDataAngle
    const total = data.map((e) => e[dataKey]).reduce((sum, current) => sum + current, 0)

    const isEmpty = total === 0
    if (isEmpty) {
      data = [{}]
      data[0][dataKey] = 100
    }
    return (
      <recharts.ResponsiveContainer width={"100%"} height={"100%"}>
        <recharts.PieChart>
          {!isEmpty && <recharts.Tooltip cursor={false} content={<PieChartTooltip total={total} />} wrapperStyle={pieTooltipStyles} />}
          <recharts.Pie data={data} dataKey={dataKey} innerRadius={75} startAngle={90} endAngle={-270} rootTabIndex={-1}>
            <recharts.Label className={styles["label"]} value={label} fill="#5C5761" position="center" />
            {isEmpty || data.map((entry, index) => <recharts.Cell key={`cell-${index}`} fill={colors[index]} strokeWidth={1} />)}
            {!isEmpty || <recharts.Cell fill="#DCDEE0" strokeWidth={1} />}
          </recharts.Pie>
          {innerData.length > 0 && (
            <recharts.Pie data={innerData} dataKey="value" innerRadius="70%" startAngle={90} endAngle={90 + innerDataAngle} rootTabIndex={-1}>
              <recharts.Cell fill={innerDataColor} strokeWidth={1} />
            </recharts.Pie>
          )}
        </recharts.PieChart>
      </recharts.ResponsiveContainer>
    )
  }
}
